import { Injectable } from  '@angular/core';
import { HttpClient, HttpHeaders } from  '@angular/common/http';
import { Globals } from 'projects/shared/models/Globals';

@Injectable({
  providedIn: 'root'
})
export class MummyGameService {

  constructor(private  httpClient:  HttpClient) { }

  getMummyGameQuestions(input){
    return this.httpClient.post(`${Globals.BaseUrl}/ChildWorld/GetMummyGameQuestions`, input, {
        headers: new HttpHeaders().set('culture', Globals.Culture)
      });
  }  

  saveScore(score){
    return this.httpClient.post(`${Globals.BaseUrl}/ChildWorld/SaveMemberScore`, score, {
        headers: new HttpHeaders().set('culture', Globals.Culture)
      });
  } 

}
